import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Cta from "./Cta";

const Hero = ({ home }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
  };
  return (
    <div>
      <div
        className="site-slider"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
        }}
      >
        <Slider {...settings}>
          <div>
            <div className="overlay"> </div>
            <img
              src={home.slider1.url}
              alt="International Conference"
              className="img-responsive"
            />
          </div>
          <div>
            <div className="overlay"> </div>
            <img
              src={home.slider2.url}
              alt="Event Date"
              className="img-responsive"
            />
          </div>
          <div>
            <div className="overlay"> </div>
            <img
              src={home.slider3.url}
              alt="Location"
              className="img-responsive"
            />
          </div>
        </Slider>
      </div>
      <div className="sitee container">
        <h1 className="text-center gradient-text">{home.acroynm[0].text}</h1>
        <p className="lead">(Hybrid Mode)</p>
        <div className="conference-date text-white py-2 px-4 mt-4 rounded">
          <h3>{home.conference_date[0].text}</h3>
        </div>
        <div className="conference-organised mt-3 h5 font-weight-medium">
          <h2>{home.location[0].text}</h2>
        </div>
        <div className="d-flex flex-row justify-content-center">
          <a
            className="nav-link link-button scrollto mx-3"
            target="_blank"
            href={home.paper_submission_link[0].text}
            rel="noopener noreferrer"
          >
            <button className="btn btn-light nav-btn nav-btn-mobile register-btn">
              Paper Submission
            </button>
          </a>

          <a
            className="nav-link link-button scrollto mx-3"
            target="_blank"
            href={home.registration_link[0].text}
            rel="noopener noreferrer"
          >
            <button className="btn btn-light nav-btn nav-btn-mobile register-btn">
              Registration
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
